import { ApplicationConfig, LOCALE_ID, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideEchartsCore } from 'ngx-echarts';
import * as echarts from 'echarts/core';
import {
  BarChart,
  LineChart,
  PieChart,
  GaugeChart,
  BoxplotChart,
  FunnelChart,
  RadarChart,
} from 'echarts/charts';
import { registerLocaleData } from '@angular/common';
import { MatPaginatorIntl } from '@angular/material/paginator';
import localeEsBO from '@angular/common/locales/es-BO';
import {
  provideRouter,
  withComponentInputBinding,
  withHashLocation,
  withInMemoryScrolling,
} from '@angular/router';
import { authInterceptor } from '@shared/interceptors/auth.interceptor';
import { errorInterceptor } from '@shared/interceptors/error.interceptor';
import { getSpanishPaginatorIntl } from '@shared/locales/spanish-mat-paginator-intl';

import { loaderInterceptor } from '@shared/interceptors/loader.interceptor';
import { tokenInterceptor } from '@shared/interceptors/token.interceptor';
import { routes } from './app.routes';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import {
  GridComponent,
  TooltipComponent,
  LegendComponent,
  TitleComponent,
  DataZoomComponent,
  ToolboxComponent,
  VisualMapComponent,
} from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatDateFormats } from '@angular/material/core';
import { provideLuxonDateAdapter } from '@angular/material-luxon-adapter';
import { MAT_CARD_CONFIG } from '@angular/material/card';
import { MatDatepickerIntl } from '@angular/material/datepicker';
import { getSpanishDatepickerIntl } from '@shared/locales/spanish-datepicker-intl';
const BOLIVIA_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: 'dd/MM/yyyy', // Cómo lo lee cuando tú escribes
    timeInput: 'HH:mm',
  },
  display: {
    dateInput: 'dd/MM/yyyy', // Cómo se muestra en el input
    timeInput: 'HH:mm', // <--- Requerido por MatTimepicker
    timeOptionLabel: 'HH:mm', // <--- Requerido por MatTimepicker
    monthYearLabel: 'MMM yyyy',
    dateA11yLabel: 'DDD',
    monthYearA11yLabel: 'MMMM yyyy',
  },
};
registerLocaleData(localeEsBO);
// Registramos los módulos necesarios para todo el proyecto
echarts.use([
  BarChart,
  LineChart,
  PieChart,
  GaugeChart,
  FunnelChart,
  BoxplotChart,
  RadarChart,
  GridComponent,
  TooltipComponent,
  ToolboxComponent,
  LegendComponent,
  VisualMapComponent,
  TitleComponent,
  DataZoomComponent,
  CanvasRenderer,
]);

export const appConfig: ApplicationConfig = {
  providers: [
    provideLuxonDateAdapter(),
    provideHttpClient(
      withInterceptors([loaderInterceptor, tokenInterceptor, authInterceptor, errorInterceptor]),
    ),
    provideBrowserGlobalErrorListeners(),
    provideRouter(
      routes,
      withComponentInputBinding(),
      withHashLocation(),
      withInMemoryScrolling({
        scrollPositionRestoration: 'top', // Forza el scroll arriba en cada navegación
      }),
    ),
    provideEchartsCore({ echarts }),
    { provide: MAT_DATE_FORMATS, useValue: BOLIVIA_DATE_FORMATS },
    { provide: LOCALE_ID, useValue: 'es-BO' },
    { provide: MAT_DATE_LOCALE, useValue: 'es-BO' },
    { provide: MatPaginatorIntl, useValue: getSpanishPaginatorIntl() },
    { provide: MatDatepickerIntl, useValue: getSpanishDatepickerIntl() },
    {
      provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
      useValue: {
        duration: 5000,
      },
    },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        appearance: 'outline',
        floatLabel: 'auto',
      },
    },
    {
      provide: MAT_CARD_CONFIG,
      useValue: {
        appearance: 'outlined',
      },
    },
  ],
};
